import loadScript from './load_script'

export default class GooglePlaces {

  constructor(apiKey, searchInput) {
    this.apiKey = apiKey
    this.searchInput = searchInput

    this.autocomplete = undefined

    return new Promise((resolve) => {
      let mapsUrl = 'https://maps.googleapis.com/maps/api/js?key=' + this.apiKey + '&libraries=places&language=de-DE'
      loadScript(mapsUrl)
        .then(this._createPlaces.bind(this))
        .then(resolve(this))
    })
  }

  _createPlaces() {

    this.autocomplete = new google.maps.places.Autocomplete(this.searchInput, {
      types: ['geocode'],
      componentRestrictions: {country: 'de'},
    })
    this.autocomplete.addListener('place_changed', () => {
      up.emit(this.searchInput, 'app:map:placeChanged')
    })
  }
}
